import { useIntercom } from "react-use-intercom";

import RenderIf from "common/components/RenderIf";
import Alert from "common/components/ui/Alert";
import { Button } from "common/components/ui/Button";
import Switch from "common/components/ui/Switch";
import { Tag } from "common/components/ui/Tag";

import useAgencySettings from "../../../datahooks/useAgencySettings";
import useAgencySettingsMutations from "../../../datahooks/useAgencySettingsMutations";
import SettingsItemContainer from "../../SettingsItemContainer";
import ExtensionID from "./ExtensionID";

export default function Index() {
  const { showNewMessage } = useIntercom();
  const { agencySettings } = useAgencySettings();
  const { updateAgencySettings } = useAgencySettingsMutations();

  return (
    <SettingsItemContainer className="flex-col">
      <div className="flex items-center mb-4">
        <div className="flex flex-col flex-1">
          <div className="flex items-center gap-x-1.5 mb-1">
            <span className="text-button-sm">Chrome Extension login</span>
          </div>
          <p className="text-xs-medium text-black-500">
            Let your customers connect LinkedIn accounts via Chrome extension
          </p>
        </div>
        <Switch
          checked={agencySettings.use_chrome_extension}
          onCheckedChange={(isChecked) =>
            updateAgencySettings({
              updates: { use_chrome_extension: isChecked },
            })
          }
        />
      </div>

      <RenderIf condition={!!agencySettings.use_chrome_extension}>
        <ExtensionID />
        <RenderIf condition={!agencySettings.extension_id}>
          <Alert className="mr-auto w-[440px] mt-4">
            <div className="flex flex-col">
              <div className="gap-x-1.5 flex items-center mb-1 text-xs-bold">
                Branded Chrome Extension
                <Tag size="sm">Premium</Tag>
              </div>
              Get a custom Chrome extension with your agency's name, logo, and
              branding for a seamless client experience.
              <ul className="list-disc ml-6 mt-2">
                <li>Your agency logo and name</li>
                <li>Custom extension icon</li>
                <li>Published under your developer account</li>
              </ul>
              <Button
                size="sm"
                variant="secondary-purple"
                className="mt-2.5 ml-auto"
                onClick={() => {
                  showNewMessage(
                    "Hello, I would like to update my agency whitelabel extension",
                  );
                }}
              >
                Contact support
              </Button>
            </div>
          </Alert>
        </RenderIf>
      </RenderIf>
    </SettingsItemContainer>
  );
}
